export enum LotOfferStatus {
    Offered = 0,
    Accepted = 1,
    Rejected = 2,
    Cancelling = 3,
    Cancelled = 4,
}
